import type { Article, Category, Work, NewsItem } from '@/types';

export const categories: Category[] = [
  { slug: 'profile', name: '个人资料', nameJa: 'プロフィール', description: '小野坂唯香的详细个人资料与背景介绍', icon: 'ri-user-heart-line' },
  { slug: 'works', name: '代表作品', nameJa: '代表作品', description: '影视、音乐、舞台等全方位作品展示', icon: 'ri-film-line' },
  { slug: 'news', name: '最新动态', nameJa: '最新情報', description: '最新活动、演出、采访及新闻资讯', icon: 'ri-flashlight-line' },
  { slug: 'fanclub', name: '粉丝应援', nameJa: 'ファンクラブ', description: '粉丝活动、应援信息与社区互动', icon: 'ri-heart-pulse-line' },
];

export const articles: Article[] = [
  {
    id: 'debut-story',
    title: '小野坂唯香出道全记录：从练习生到闪耀新星',
    excerpt: '回顾小野坂唯香从13岁开始接受训练，到17岁正式出道的完整历程。从最初默默无闻的练习生，到如今备受瞩目的实力派艺人，她的每一步都充满了坚持与热爱。',
    content: `
      <h2>初识舞台：13岁的梦想起点</h2>
      <p>小野坂唯香出生于1998年3月15日，东京都出身。自幼便展现出对表演艺术的浓厚兴趣，13岁时通过选拔进入知名艺能事务所，开始了严格的训练生涯。在长达四年的练习生时期，她每天坚持超过10小时的声乐、舞蹈和表演训练。</p>
      <p>据同期练习生回忆："唯香总是最早到练习室、最晚离开的那一个。她对舞台的热爱，从眼神里就能看出来。"</p>

      <h2>出道前夕：积蓄力量的17岁</h2>
      <p>2015年，17岁的小野坂唯香在事务所内部选拔中以绝对优势脱颖而出，获得了出道资格。同年秋季，她以单曲《First Light》正式出道，清澈而富有穿透力的嗓音一经推出便引发业界关注。</p>
      <p>出道曲《First Light》在发行首周便登上Oricon单曲榜前20位，对于一位新人来说，这是一个令人瞩目的成绩。音乐评论人评价她的声音"纯净中带着力量，既有少女的清澈，又有超越年龄的表现力"。</p>

      <h2>多元发展：从歌手到演员的蜕变</h2>
      <p>2017年，小野坂唯香开始涉足影视领域，首部参演的电视剧《夏日奇迹》中，她饰演的女高中生角色获得观众一致好评。此后，她陆续参演了多部热门剧集和电影，逐渐建立起作为演员的声誉。</p>
      <p>2020年，她在电影《星之所在》中首次担任女主角，凭借细腻的表演获得了当年日本电影学院奖最佳新人提名，这标志着她在演艺道路上迈出了重要的一步。</p>

      <h2>持续进化：永不止步的艺人之路</h2>
      <p>进入2020年代，小野坂唯香在音乐、影视、舞台剧等多个领域持续发力。2023年，她举办了首次个人巡回演唱会，横跨东京、大阪、名古屋、福冈四大城市，场场爆满。2024年，她更受邀参与了多项国际文化交流活动，影响力逐步扩展至海外。</p>
      <p>正如她在一次采访中所说："我希望自己的每一步都能带给粉丝新的惊喜。艺人的路没有终点，每一天都是新的起点。"</p>
    `,
    image: 'https://readdy.ai/api/search-image?query=Elegant%20young%20Japanese%20female%20performer%20on%20stage%20in%20a%20spotlight%2C%20graceful%20standing%20pose%20with%20microphone%2C%20dreamy%20warm%20golden%20stage%20lighting%20with%20soft%20bokeh%20effects%2C%20cherry%20blossom%20petals%20scattered%20in%20the%20air%2C%20professional%20concert%20photography%2C%20shallow%20depth%20of%20field%2C%20warm%20rose%20and%20gold%20color%20tones%2C%20emotional%20performance%20moment&width=1200&height=675&seq=article-debut&orientation=landscape',
    date: '2024-12-20',
    category: 'profile',
    tags: ['出道', '演艺经历', '成长故事'],
    author: '编辑部',
    featured: true,
  },
  {
    id: '2025-spring-tour',
    title: '2025春季巡演「花咲く季節」正式公布，全国六大城市巡演确定',
    excerpt: '小野坂唯香正式宣布2025年春季全国巡演计划，将覆盖东京、大阪、札幌等六大城市。本次巡演以"花开的季节"为主题，将带来全新编排的舞台表演。',
    content: `
      <h2>巡演官宣：六城联动，春日之约</h2>
      <p>小野坂唯香于近日正式公布了2025年春季全国巡演「花咲く季節」（花开的季节）的详细计划。本次巡演将从2025年3月15日——她27岁生日当天，在东京拉开帷幕，随后巡演至大阪、名古屋、札幌、福冈和仙台，共计六座城市。</p>
      <p>这是小野坂唯香继2023年首次个人巡演之后的第二次全国巡演，规模更大、场次更多，充分展现了她在日本国内持续攀升的人气。</p>

      <h2>主题概念：花开的季节</h2>
      <p>本次巡演以"花开的季节"为核心概念，寓意着艺人与粉丝共同成长的历程。据制作团队透露，整场演出将分为"种子"、"萌芽"、"绽放"三个篇章，每个篇章都有独特的舞台设计和曲目编排。</p>
      <p>小野坂唯香本人表示："春天是我最喜欢的季节，也是我生日的季节。希望能在这个美好的时节，与大家一起创造难忘的回忆。"</p>

      <h2>票务信息</h2>
      <p>粉丝俱乐部会员可于2025年1月10日起优先购票，普通售票将于1月25日正式开启。各场次票价统一为8,800日元（含税），VIP席位15,000日元（含税），VIP席位包含限定周边礼品及演出后握手会参与资格。</p>
    `,
    image: 'https://readdy.ai/api/search-image?query=Japanese%20concert%20stage%20with%20elegant%20performance%20atmosphere%2C%20cherry%20blossom%20themed%20stage%20design%20with%20pink%20illumination%2C%20large%20venue%20with%20crowd%20lights%2C%20warm%20spring%20atmosphere%2C%20professional%20concert%20photography%2C%20wide%20angle%20shot%20showing%20stage%20and%20audience%2C%20soft%20dreamy%20lighting%20in%20rose%20and%20gold&width=1200&height=675&seq=article-tour&orientation=landscape',
    date: '2025-01-08',
    category: 'news',
    tags: ['巡演', '演唱会', '2025'],
    author: '编辑部',
    featured: true,
  },
  {
    id: 'new-drama-2025',
    title: '主演新剧《月光庭园》即将开播，挑战古典音乐家角色',
    excerpt: '小野坂唯香将在2025年春季档新剧《月光庭园》中饰演一位年轻的天才钢琴家。这是她首次挑战音乐题材剧集，为此她接受了长达半年的钢琴特训。',
    content: `
      <h2>新剧官宣：古典音乐与青春物语</h2>
      <p>NHK电视台正式宣布，2025年春季档新剧《月光庭园》（月光庭園）将由小野坂唯香担纲主演。该剧讲述了一位年轻钢琴家在追求音乐梦想过程中经历的成长与蜕变，是一部融合古典音乐与青春群像的感人作品。</p>
      <p>小野坂唯香在剧中饰演女主角"月岛樱"，一位出身音乐世家、背负家族期望的天才钢琴少女。角色需要展现从16岁到25岁的年龄跨度，对演技是不小的考验。</p>

      <h2>半年的钢琴特训</h2>
      <p>为了更好地诠释角色，小野坂唯香在拍摄前接受了长达半年的专业钢琴训练。她每天坚持练习3-4小时，从零基础到能够完整弹奏肖邦的《夜曲》和贝多芬的《月光奏鸣曲》选段。</p>
      <p>钢琴指导老师评价道："唯香的学习能力非常惊人，半年的时间能达到这个水平，除了天赋，更多的是刻苦。剧中的近景弹奏镜头都是她自己完成的。"</p>

      <h2>播出信息</h2>
      <p>《月光庭园》将于2025年4月5日起每周六晚间9点在NHK综合频道播出，全10集。官方同步推出了先行预告片和幕后特辑，引发粉丝热烈讨论。</p>
    `,
    image: 'https://readdy.ai/api/search-image?query=Elegant%20young%20Japanese%20woman%20sitting%20at%20a%20grand%20piano%20in%20a%20softly%20lit%20classical%20music%20hall%2C%20wearing%20a%20refined%20dress%2C%20warm%20golden%20light%20streaming%20through%20windows%2C%20artistic%20cinematic%20composition%2C%20shallow%20depth%20of%20field%2C%20sophisticated%20warm%20tones%2C%20professional%20film%20still%20quality&width=1200&height=675&seq=article-drama&orientation=landscape',
    date: '2025-02-15',
    category: 'news',
    tags: ['电视剧', '钢琴', '音乐'],
    author: '编辑部',
    featured: true,
  },
  {
    id: 'profile-detail',
    title: '小野坂唯香 完整个人档案',
    excerpt: '全面了解小野坂唯香的个人资料，包括基本信息、身高、兴趣爱好、特长等详细档案。',
    content: `
      <h2>基本资料</h2>
      <table>
        <tr><td>姓名</td><td>小野坂 唯香（おのさか ゆいか / Onosaka Yuika）</td></tr>
        <tr><td>出生日期</td><td>1998年3月15日</td></tr>
        <tr><td>出生地</td><td>日本 东京都</td></tr>
        <tr><td>身高</td><td>162cm</td></tr>
        <tr><td>血型</td><td>A型</td></tr>
        <tr><td>星座</td><td>双鱼座</td></tr>
        <tr><td>职业</td><td>歌手、演员、声优</td></tr>
        <tr><td>出道年份</td><td>2015年</td></tr>
        <tr><td>所属事务所</td><td>StarRise Entertainment</td></tr>
        <tr><td>官方粉丝俱乐部</td><td>「YUIKA♡LAB」（ゆいかラボ）</td></tr>
      </table>

      <h2>兴趣爱好与特长</h2>
      <p>兴趣爱好包括摄影、烘焙、阅读和旅行。她经常在社交媒体上分享自己拍摄的照片，以独特的构图和温暖的色调获得了粉丝的一致好评。此外，她擅长钢琴（经过专业训练）、书法（师从著名书法家三年）和英语（TOEIC 850分），展现了多方面的才华。</p>

      <h2>性格特点</h2>
      <p>在公众面前，小野坂唯香给人的印象是温柔、认真且专业。但在幕后花絮和综艺节目中，她也展现出了幽默感和亲和力。合作过的演员和工作人员普遍评价她"非常敬业"、"对工作极其认真"、"私下很可爱"。她自己则形容自己是"典型的A型血——有点完美主义倾向"。最喜欢的颜色是淡粉色和白色，喜欢的食物是草莓大福和抹茶拿铁。</p>
    `,
    image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20photography%20of%20a%20young%20Japanese%20female%20celebrity%2C%20natural%20warm%20lighting%2C%20elegant%20and%20fresh%20aesthetic%2C%20soft%20cream%20background%2C%20wearing%20a%20simple%20elegant%20outfit%2C%20gentle%20smile%2C%20editorial%20magazine%20quality%2C%20warm%20neutral%20tones%2C%20clean%20sophisticated%20composition&width=1200&height=675&seq=article-profile&orientation=landscape',
    date: '2025-01-01',
    category: 'profile',
    tags: ['个人资料', '档案', '简介'],
    author: '编辑部',
    featured: false,
  },
  {
    id: 'fan-meeting-2024',
    title: '2024年粉丝见面会回顾：温暖与感动交织的特别之夜',
    excerpt: '回顾2024年12月在东京举办的粉丝见面会，小野坂唯香与600名幸运粉丝共度温馨时光，现场惊喜环节让粉丝感动落泪。',
    content: `
      <h2>温馨之夜：600名粉丝的特别聚会</h2>
      <p>2024年12月22日，小野坂唯香在东京国际论坛举办了年度粉丝见面会「YUIKA's Winter Wonderland」。本次活动通过抽选方式邀请了600名幸运粉丝参加，现场座无虚席，气氛温馨而热烈。</p>
      <p>见面会以一段精心制作的回顾VCR开场，记录了小野坂唯香过去一年的重要时刻。当她本人从舞台中央缓缓升起时，全场爆发出热烈的欢呼声。</p>

      <h2>惊喜环节：亲手写给每位粉丝的信</h2>
      <p>本次见面会最大的惊喜环节出现在中场：小野坂唯香宣布为到场的每一位粉丝都准备了一封手写的感谢信。600封信全部由她亲笔书写，花费了整整两个月的时间。</p>
      <p>"每封信虽然只有几行字，但每一个字都是我真心想对大家说的。"她说这番话时，台下许多粉丝忍不住流下了感动的泪水。</p>

      <h2>未来展望</h2>
      <p>在见面会的最后，小野坂唯香透露了2025年的部分计划，包括春季巡演和新剧出演。她表示："因为有大家的支持，我才能不断挑战新的领域。2025年，请继续多多关照。"</p>
    `,
    image: 'https://readdy.ai/api/search-image?query=Japanese%20fan%20meeting%20event%20at%20a%20warm%20intimate%20venue%2C%20stage%20decorated%20with%20winter%20wonderland%20theme%2C%20soft%20warm%20fairy%20lights%2C%20emotional%20atmosphere%2C%20fans%20holding%20penlights%2C%20cozy%20and%20heartwarming%20scene%2C%20professional%20event%20photography%2C%20warm%20golden%20rose%20lighting&width=1200&height=675&seq=article-fanmeet&orientation=landscape',
    date: '2024-12-25',
    category: 'fanclub',
    tags: ['粉丝见面会', '活动', '回顾'],
    author: '编辑部',
    featured: false,
  },
  {
    id: 'photobook-2025',
    title: '全新写真集《花便り》发行决定，收录未公开生活照',
    excerpt: '小野坂唯香宣布将于2025年春季发行第三本个人写真集《花便り》，在京都、镰仓等古都取景，收录大量自然风格写真。',
    content: `
      <h2>第三本写真集即将问世</h2>
      <p>小野坂唯香正式宣布，将于2025年3月15日（生日当天）发行第三本个人写真集《花便り》（花信）。这是她时隔两年再次推出写真集，消息一出便引发粉丝热烈期待。</p>
      <p>本次写真集在京都、镰仓、奈良三座古都取景，以"四季之花"为主题，展现了小野坂唯香在樱花、紫阳花、红叶等不同季节花卉映衬下的多样魅力。</p>

      <h2>自然风格与素颜之美</h2>
      <p>据制作团队透露，本次写真集最大特点是"自然感"。相比前两本写真集更加注重生活化的场景，包含大量未公开的日常照片。摄影师特意选择在清晨和黄昏的自然光下拍摄，营造出温柔、细腻的质感。</p>
      <p>小野坂唯香表示："这次我想让大家看到更真实的我。素颜也好，日常也好，都是小野坂唯香的一部分。"</p>
    `,
    image: 'https://readdy.ai/api/search-image?query=Japanese%20young%20female%20celebrity%20in%20a%20traditional%20kimono%20walking%20through%20a%20Kyoto%20bamboo%20forest%20pathway%2C%20soft%20morning%20sunlight%20filtering%20through%20leaves%2C%20elegant%20natural%20photography%20style%2C%20warm%20earthy%20tones%2C%20serene%20and%20artistic%20composition%2C%20editorial%20quality%2C%20dreamy%20atmosphere&width=1200&height=675&seq=article-photobook&orientation=landscape',
    date: '2025-02-01',
    category: 'works',
    tags: ['写真集', '出版', '写真'],
    author: '编辑部',
    featured: false,
  },
  {
    id: 'charity-2024',
    title: '参与儿童教育公益活动，担任"未来之星"项目大使',
    excerpt: '小野坂唯香被任命为"未来之星"儿童艺术教育公益项目的大使，将参与多项募捐及宣传活动，为贫困地区儿童的艺术教育提供支持。',
    content: `
      <h2>公益新身份：项目大使</h2>
      <p>2024年11月，小野坂唯香正式被任命为"未来之星"（みらいの星）儿童艺术教育公益项目的大使。该项目旨在为日本偏远地区和贫困家庭的儿童提供音乐、美术等艺术教育的机会。</p>
      <p>在就任发布会上，小野坂唯香动情地说："我自己从小就有机会学习音乐和表演，这改变了我的一生。每个孩子都应该有接触艺术的机会，无论他们来自什么样的家庭。"</p>

      <h2>具体活动计划</h2>
      <p>作为项目大使，小野坂唯香将参与以下活动：定期访问参与项目的学校、举办慈善迷你演唱会、录制在线艺术课程、参与年度慈善晚宴。其中，首场慈善迷你演唱会计划于2025年夏季举办，所有收入将捐赠给该项目。</p>
    `,
    image: 'https://readdy.ai/api/search-image?query=Japanese%20female%20celebrity%20interacting%20warmly%20with%20children%20in%20a%20classroom%20setting%2C%20soft%20natural%20lighting%2C%20heartwarming%20educational%20atmosphere%2C%20children%20smiling%20and%20engaging%20in%20art%20activities%2C%20documentary%20style%20photography%2C%20warm%20genuine%20emotions%2C%20elegant%20casual%20outfit&width=1200&height=675&seq=article-charity&orientation=landscape',
    date: '2024-11-20',
    category: 'news',
    tags: ['公益', '慈善', '教育'],
    author: '编辑部',
    featured: false,
  },
  {
    id: 'works-compilation',
    title: '小野坂唯香 代表作品大全（持续更新）',
    excerpt: '全面盘点小野坂唯香的音乐、影视、舞台剧等代表作品，包含详细的作品信息和获得的荣誉。',
    content: `
      <h2>音乐作品</h2>
      <h3>单曲</h3>
      <ul>
        <li>《First Light》（2015年）—— 出道单曲，Oricon周榜最高第18位</li>
        <li>《夏の記憶》（2016年）—— Oricon周榜最高第12位</li>
        <li>《星屑のワルツ》（2017年）—— 电视剧《星空下的约定》主题曲</li>
        <li>《Brave Heart》（2019年）—— 首次尝试摇滚风格</li>
        <li>《花言葉》（2021年）—— 数字单曲，流媒体播放量突破5000万</li>
        <li>《Moonlight Letter》（2023年）—— 首次个人作词作曲</li>
      </ul>
      <h3>专辑</h3>
      <ul>
        <li>《YUIKA》（2017年）—— 首张个人专辑，收录12首曲目</li>
        <li>《Colors of Me》（2020年）—— 第二张专辑，展现多元音乐风格</li>
        <li>《Blooming》（2023年）—— 第三张专辑，首次巡回演唱会同期发行</li>
      </ul>

      <h2>影视作品</h2>
      <h3>电视剧</h3>
      <ul>
        <li>《夏日奇迹》（2017年）—— 饰演 铃木花音（女配角）</li>
        <li>《星空下的约定》（2017年）—— 饰演 星野真昼（女主角）</li>
        <li>《东京爱情故事2020》（2020年）—— 饰演 赤名リカ（女主角）</li>
        <li>《白衣之誓》（2022年）—— 饰演 护士 山田优子</li>
        <li>《月光庭园》（2025年）—— 饰演 月岛樱（女主角）</li>
      </ul>
      <h3>电影</h3>
      <ul>
        <li>《星之所在》（2020年）—— 女主角，获日本电影学院奖最佳新人提名</li>
        <li>《风之记忆》（2022年）—— 女主角，票房突破15亿日元</li>
        <li>《樱花飘落的季节》（2024年）—— 女主角</li>
      </ul>
    `,
    image: 'https://readdy.ai/api/search-image?query=Collage%20style%20artistic%20composition%20of%20Japanese%20entertainment%20media%2C%20vinyl%20records%2C%20film%20strips%2C%20stage%20curtains%2C%20musical%20notes%2C%20warm%20golden%20and%20rose%20ambient%20lighting%2C%20creative%20editorial%20layout%2C%20elegant%20artistic%20arrangement%2C%20sophisticated%20warm%20tones&width=1200&height=675&seq=article-works&orientation=landscape',
    date: '2025-02-10',
    category: 'works',
    tags: ['作品集', '音乐', '影视'],
    author: '编辑部',
    featured: false,
  },
];

export const works: Work[] = [
  {
    id: 'work-1',
    title: '专辑《Blooming》',
    type: '音乐',
    year: '2023',
    description: '第三张个人专辑，收录14首曲目，包含首次个人创作的主打歌《Moonlight Letter》',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20music%20album%20cover%20aesthetic%2C%20blooming%20flowers%20in%20soft%20focus%2C%20minimalist%20design%20with%20warm%20rose%20and%20gold%20tones%2C%20Japanese%20CD%20album%20packaging%20style%2C%20artistic%20product%20photography%2C%20clean%20simple%20composition%20with%20subtle%20light%20reflections%2C%20sophisticated%20feminine%20aesthetic&width=800&height=800&seq=work-blooming&orientation=squarish',
    featured: true,
  },
  {
    id: 'work-2',
    title: '电影《星之所在》',
    type: '电影',
    year: '2020',
    description: '首次担任电影女主角，获日本电影学院奖最佳新人提名，票房突破10亿日元',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20aesthetic%2C%20starry%20night%20sky%20with%20warm%20golden%20light%2C%20Japanese%20film%20poster%20style%2C%20elegant%20female%20silhouette%20looking%20at%20stars%2C%20dreamy%20romantic%20atmosphere%2C%20minimalist%20sophisticated%20design%2C%20warm%20navy%20and%20gold%20tones&width=800&height=800&seq=work-hoshi&orientation=squarish',
    featured: true,
  },
  {
    id: 'work-3',
    title: '写真集《花便り》',
    type: '出版',
    year: '2025',
    description: '第三本个人写真集，在京都、镰仓取景，以"四季之花"为主题',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20photobook%20cover%20aesthetic%2C%20cherry%20blossoms%20and%20traditional%20Japanese%20scenery%2C%20soft%20natural%20lighting%2C%20elegant%20feminine%20portrait%20style%2C%20warm%20pastel%20tones%2C%20artistic%20book%20cover%20design%2C%20sophisticated%20editorial%20quality&width=800&height=800&seq=work-photobook&orientation=squarish',
    featured: true,
  },
  {
    id: 'work-4',
    title: '电视剧《月光庭园》',
    type: '电视剧',
    year: '2025',
    description: 'NHK春季档主演，饰演天才钢琴少女月岛樱，挑战古典音乐题材',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20television%20drama%20poster%20aesthetic%2C%20grand%20piano%20in%20moonlit%20garden%2C%20soft%20magical%20atmosphere%2C%20elegant%20artistic%20composition%2C%20warm%20silver%20and%20rose%20tones%2C%20sophisticated%20cinematic%20style%2C%20dreamy%20night%20scene%20with%20subtle%20lighting&width=800&height=800&seq=work-drama&orientation=squarish',
    featured: false,
  },
  {
    id: 'work-5',
    title: '单曲《花言葉》',
    type: '音乐',
    year: '2021',
    description: '数字单曲，流媒体平台累计播放量突破5000万次，成为年度热门曲目',
    image: 'https://readdy.ai/api/search-image?query=Music%20single%20cover%20design%2C%20delicate%20flowers%20with%20soft%20pastel%20colors%2C%20minimalist%20Japanese%20CD%20jacket%20aesthetic%2C%20elegant%20typography%2C%20warm%20gentle%20atmosphere%2C%20artistic%20product%20photography%2C%20clean%20sophisticated%20composition&width=800&height=800&seq=work-hanakotoba&orientation=squarish',
    featured: false,
  },
  {
    id: 'work-6',
    title: '电影《风之记忆》',
    type: '电影',
    year: '2022',
    description: '主演爱情电影，票房突破15亿日元，获观众票选最受欢迎女演员',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20romance%20film%20poster%20style%2C%20flowing%20hair%20in%20gentle%20breeze%2C%20warm%20sunset%20golden%20hour%20lighting%2C%20emotional%20cinematic%20composition%2C%20soft%20dreamy%20bokeh%20background%2C%20elegant%20artistic%20aesthetic%2C%20warm%20amber%20and%20rose%20tones&width=800&height=800&seq=work-kaze&orientation=squarish',
    featured: false,
  },
];

export const newsItems: NewsItem[] = [
  { id: 'news-1', title: '2025春季巡演「花咲く季節」门票火热发售中', date: '2025-01-25', category: 'event', image: 'https://readdy.ai/api/search-image?query=Concert%20ticket%20and%20stage%20announcement%20visual%2C%20elegant%20cherry%20blossom%20themed%20design%2C%20warm%20pink%20and%20gold%20lighting%2C%20Japanese%20concert%20promotion%20poster%20style%2C%20artistic%20typography%2C%20sophisticated%20event%20marketing%20aesthetic&width=600&height=400&seq=news-concert&orientation=landscape' },
  { id: 'news-2', title: '新剧《月光庭园》预告片公开，粉丝反响热烈', date: '2025-02-20', category: 'media', image: 'https://readdy.ai/api/search-image?query=Television%20drama%20teaser%20visual%2C%20grand%20piano%20in%20spotlight%2C%20elegant%20cinematic%20composition%2C%20warm%20dramatic%20lighting%2C%20Japanese%20TV%20drama%20promotional%20aesthetic%2C%20sophisticated%20mood&width=600&height=400&seq=news-drama-pv&orientation=landscape' },
  { id: 'news-3', title: '写真集《花便り》预购量突破5万册', date: '2025-02-28', category: 'publication', image: 'https://readdy.ai/api/search-image?query=Photobook%20preorder%20announcement%20visual%2C%20stacks%20of%20elegant%20photo%20books%20with%20floral%20design%2C%20warm%20soft%20lighting%2C%20Japanese%20bookstore%20display%20aesthetic%2C%20sophisticated%20product%20photography&width=600&height=400&seq=news-book&orientation=landscape' },
  { id: 'news-4', title: '获选「2025年最受期待女艺人」第1名', date: '2025-01-10', category: 'award', image: 'https://readdy.ai/api/search-image?query=Elegant%20award%20ceremony%20visual%2C%20golden%20spotlight%20on%20stage%2C%20sophisticated%20trophy%20design%2C%20warm%20celebratory%20atmosphere%2C%20Japanese%20entertainment%20award%20aesthetic%2C%20refined%20composition&width=600&height=400&seq=news-award&orientation=landscape' },
  { id: 'news-5', title: '将出席2025年东京国际电影节开幕式', date: '2025-03-01', category: 'event', image: 'https://readdy.ai/api/search-image?query=International%20film%20festival%20red%20carpet%20visual%2C%20elegant%20venue%20with%20warm%20lighting%2C%20Japanese%20cinema%20event%20atmosphere%2C%20sophisticated%20event%20photography%20aesthetic%2C%20glamorous%20yet%20refined&width=600&height=400&seq=news-festival&orientation=landscape' },
  { id: 'news-6', title: '与知名品牌合作推出限定联名系列', date: '2025-02-05', category: 'collaboration', image: 'https://readdy.ai/api/search-image?query=Japanese%20celebrity%20fashion%20brand%20collaboration%20visual%2C%20elegant%20product%20display%20with%20warm%20lighting%2C%20minimalist%20luxury%20aesthetic%2C%20sophisticated%20brand%20partnership%20photography%2C%20clean%20refined%20composition&width=600&height=400&seq=news-collab&orientation=landscape' },
];

export const aboutInfo = {
  brandName: '小野坂唯香 中文粉丝资讯站',
  introduction: '本网站致力于为华语地区的粉丝提供关于日本艺人小野坂唯香（Onosaka Yuika）最全面、最及时的中文资讯。我们汇聚了个人资料、代表作品、最新动态以及粉丝应援等全方位内容，旨在成为连接小野坂唯香与华语粉丝之间的桥梁。',
  mission: '我们的使命是打破语言障碍，让每一位华语粉丝都能第一时间了解小野坂唯香的最新动态。我们坚持以准确、客观、全面的态度整理和翻译每一条信息，确保粉丝获得最优质的内容体验。',
  values: ['准确可靠', '及时更新', '粉丝为先', '内容优质'],
  achievements: [
    { number: '50+', label: '原创文章' },
    { number: '10万+', label: '月访问量' },
    { number: '3万+', label: '社交媒体粉丝' },
    { number: '100%', label: '中文原创内容' },
  ],
  contact: {
    email: 'contact@shiyaa.cn',
    weibo: '@小野坂唯香中文应援站',
    bilibili: '小野坂唯香中文站',
    address: '中国上海市',
  },
};